<div class="flex flex-col gap-4">
  <div class="flex justify-between">
    <form class="flex flex-col gap-4" [formGroup]="form">
      <mat-slide-toggle formControlName="testModeEnabled" color="primary">
        Enable Test Mode
      </mat-slide-toggle>
    </form>

    <img class="logo" src="/assets/integrations/twilio-logo.svg" />
  </div>

  <form *prIsManagement class="flex flex-col" [formGroup]="managementForm">
    <div class="flex flex-col gap-4">
      <small>
        The Account SID and Auth Token are retreived from the corresponding
        Workspaces Sub-account in Twilio. Any phone numbers that are added below
        must be active in the Sub-account within Twilio. Only management has the
        ability to add and archive phone numbers.
      </small>

      <mat-slide-toggle formControlName="enabled" color="primary">
        Enable Integration
      </mat-slide-toggle>

      <div class="flex gap-4">
        <mat-form-field class="flex-1">
          <mat-label>Account SID</mat-label>
          <input matInput formControlName="accountSid" />

          <button
            matIconSuffix
            mat-icon-button
            matTooltip="Copy to clipboard"
            [cdkCopyToClipboard]="managementForm.controls.accountSid.value"
            (click)="snackBar.open('Copied to clipboard')"
          >
            <mat-icon>content_copy</mat-icon>
          </button>

          <mat-hint>
            <a
              *ngIf="managementForm.controls.accountSid.value"
              href="https://console.twilio.com/us1/account/manage-account/subaccounts"
              target="_blank"
              >View in Subaccounts in Twilio</a
            >
          </mat-hint>
        </mat-form-field>

        <mat-form-field class="flex-1">
          <mat-label>Auth Token</mat-label>
          <input type="password" matInput formControlName="authToken" />

          <button
            matIconSuffix
            mat-icon-button
            matTooltip="Copy to clipboard"
            [cdkCopyToClipboard]="managementForm.controls.authToken.value"
            (click)="snackBar.open('Copied to clipboard')"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <pr-stripe-sms-pricing-selector
        [region]="region()"
        [selectedPrices]="data$ | async"
        (pricingChanged)="updatePricing($event)"
      />
    </div>
    <pt-buttons-container padding="none">
      <button
        mat-flat-button
        color="primary"
        [disabled]="managementForm.invalid"
        (click)="save()"
      >
        Save
      </button>
    </pt-buttons-container>
  </form>

  <div *prIsManagement class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <h3 class="mat-subtitle-1">Add Phone Number</h3>
      <pr-practice-phone-numbers-input
        #phoneNumberInput
        [organisation]="organisation()"
      >
        <button
          mat-icon-button
          class="mt-1"
          matTooltip="Add new practice phone number"
          [disabled]="
            phoneNumberInput.form | map: addPhoneNumberDisabled$ | async
          "
          (click)="addPhoneNumber(phoneNumberInput.form)"
        >
          <mat-icon>add</mat-icon>
        </button>
      </pr-practice-phone-numbers-input>
    </div>

    <div class="flex flex-col gap-2">
      <h3 class="mat-subtitle-1">Phone Numbers</h3>
      <ng-container *ngIf="phoneNumbers$ | async as phoneNumbers">
        <ng-container *ngIf="phoneNumbers.length; else noPhoneNumbers">
          @for (phoneNumber of phoneNumbers$ | async; track phoneNumber) {
            <div class="flex items-center">
              <div class="flex-1">{{ phoneNumber.practice.name }}</div>
              <div class="flex-1">{{ phoneNumber.phoneNumber }}</div>

              @if (!phoneNumber.disabled) {
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Archive practice phone number"
                  (click)="archivePhoneNumber(phoneNumber)"
                >
                  <mat-icon>archive</mat-icon>
                </button>
              } @else {
                <span class="basis[40px]"></span>
              }
            </div>
          }
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <h3 class="mat-subtitle-1">Phone Numbers</h3>
    <ng-container *ngIf="phoneNumbers$ | async as phoneNumbers">
      <ng-container *ngIf="phoneNumbers.length; else noPhoneNumbers">
        <div
          *ngFor="let phoneNumber of phoneNumbers; trackBy: trackByIndex"
          class="flex items-center"
        >
          <div class="flex-1">{{ phoneNumber.practice.name }}</div>
          <div class="flex-1">{{ phoneNumber.phoneNumber }}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #noPhoneNumbers>
    <small class="mat-caption">No phone numbers registered</small>
  </ng-template>

  <pr-twilio-billing-summary [data]="data$ | async" [region]="region()" />
</div>
